import script from "./RepresentanteFab.vue?vue&type=script&setup=true&lang=js"
export * from "./RepresentanteFab.vue?vue&type=script&setup=true&lang=js"

import "./RepresentanteFab.vue?vue&type=style&index=0&id=0689f7aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0689f7aa"]])

export default __exports__